import textDecor from "../assets/text-decor.svg";
import { motion } from "framer-motion";
function Title({ title }) {
  return (
    <div className="relative">
      <h2 className="pl-10 text-titleSize font-extrabold">{title}</h2>
      <motion.img
        initial={{ scale: 0 }}
        whileInView={{
          scale: 1,
          transition: { type: "spring", stiffness: 90 },
        }}
        viewport={{ once: true }}
        className="absolute top-1/2 left-0 "
        src={textDecor}
        alt=""
      />
    </div>
  );
}

export default Title;
